








































import Vue from 'vue';
import RemarkItem from './RemarkItem.vue';
import RemarkCollections from './RemarkCollections.vue';
import RemarkImport from './RemarkImport.vue';
import CustomerRemark from '../../models/CustomerRemark';
import customerClient from '../../apis';

const remarks: CustomerRemark[] = [];

export default Vue.extend({
  components: {
    RemarkItem,
    RemarkCollections,
    RemarkImport,
  },
  props: {
    mergeMode: {
      type: Boolean,
      default: false,
    },
    showRemarkImport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      size: 50,
      total: 0,
      remarks,
      loadedRemark: false,
    };
  },
  methods: {
    changePage(page: number) {
      if (this.page !== page) {
        this.page = page;
        this.getRemarks();
      }
    },
    afterImport() {
      this.getRemarks();
      this.$emit('close');
    },
    getRemarks() {
      this.loadedRemark = false;
      customerClient.getRemarks({
        page: this.page,
        size: this.size,
      }).success((r: any) => {
        this.remarks = r.remarks;
        this.total = r.total;
        this.loadedRemark = true;
      });
    },
    freezeRemark(id: number) {
      const remark = this.remarks.find((r: any) => {
        return r.id === id;
      });
      if (remark) {
        remark.status = -1;
      }
      this.$Message.success('已创建删除标签任务，请等待');
    },
    onPageChange(page: number) {
      this.page = page;
      this.getRemarks();
    },
    onPageSizeChange(pageSize: number) {
      this.size = pageSize;
      Vue.localStorage.set('remarksPageSize', pageSize);
      this.getRemarks();
    },
  },
  beforeMount() {
    this.size = parseInt(Vue.localStorage.get('remarksPageSize', 50));
  },
  mounted() {
    this.getRemarks();
  },
});
